/**
 * @generated SignedSource<<cbbca75a488f238ae5826295b5760bf7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventRulesPageQuery$variables = {
  slug: string;
};
export type EventRulesPageQuery$data = {
  readonly eventBySlug: {
    readonly id: string;
    readonly latestRule: {
      readonly id: string;
      readonly text: string;
    };
    readonly title: string;
    readonly viewerCanAccept: boolean;
    readonly viewerCanUpdate: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"EventAcceptRulesButtonEventFragment">;
  } | null | undefined;
  readonly viewer: {
    readonly id: string;
  };
};
export type EventRulesPageQuery = {
  response: EventRulesPageQuery$data;
  variables: EventRulesPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = {
  "alias": "viewerCanUpdate",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "UPDATE_EVENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"UPDATE_EVENT\")"
},
v6 = {
  "alias": "viewerCanAccept",
  "args": [
    {
      "kind": "Literal",
      "name": "action",
      "value": "CREATE_EVENT_RULE_AGREEMENT"
    }
  ],
  "kind": "ScalarField",
  "name": "viewerCan",
  "storageKey": "viewerCan(action:\"CREATE_EVENT_RULE_AGREEMENT\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EventRulesPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventBySlug",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          },
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EventAcceptRulesButtonEventFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "EventRulesPageQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v1/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": "Event",
        "kind": "LinkedField",
        "name": "eventBySlug",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EventRule",
            "kind": "LinkedField",
            "name": "latestRule",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              (v4/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "EventRuleAgreement",
                "kind": "LinkedField",
                "name": "entityAgreement",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*:: as any*/),
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0590fe56371a2917bda8225552d21375",
    "id": null,
    "metadata": {},
    "name": "EventRulesPageQuery",
    "operationKind": "query",
    "text": "query EventRulesPageQuery(\n  $slug: String!\n) {\n  viewer @ifAllowed {\n    __typename\n    id\n  }\n  eventBySlug(slug: $slug) {\n    id\n    title\n    latestRule {\n      id\n      text\n    }\n    viewerCanUpdate: viewerCan(action: UPDATE_EVENT)\n    viewerCanAccept: viewerCan(action: CREATE_EVENT_RULE_AGREEMENT)\n    ...EventAcceptRulesButtonEventFragment\n  }\n}\n\nfragment EventAcceptRulesButtonEventFragment on Event {\n  id\n  latestRule {\n    id\n    entityAgreement @ifAllowed {\n      id\n      createdAt\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7bd0d680c217a92eb6fba304ab6c9626";

export default node;
